/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Redeem_Tree_List1Inputs */

const en_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returning trees are only available to Plus members during this event.`)
};

const ar_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأشجار العائدة متاحة فقط لأعضاء Plus خلال هذا الحدث.`)
};

const de_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederkehrende Bäume sind während dieses Events nur für Plus-Mitglieder verfügbar.`)
};

const es_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los árboles de regreso solo están disponibles para los miembros Plus durante este evento.`)
};

const fr_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les arbres de retour sont uniquement disponibles pour les membres Plus pendant cet événement.`)
};

const it_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli alberi di ritorno sono disponibili solo per i membri Plus durante questo evento.`)
};

const ja_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復刻樹木は本イベント期間中、Plus会員限定で獲得できます。`)
};

const ko_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`돌아온 나무는 이번 이벤트 기간 동안 Plus 회원만 획득할 수 있습니다.`)
};

const pt_br_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As árvores de volta estão disponíveis apenas para membros Plus durante este evento.`)
};

const ru_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возвращающиеся деревья доступны только для участников Plus во время этого события.`)
};

const th_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ที่กลับมาจะเปิดให้เฉพาะสมาชิก Plus ในช่วงเวลากิจกรรมนี้เท่านั้น`)
};

const tr_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dönen ağaçlar bu etkinlik sırasında yalnızca Plus üyelerine özeldir.`)
};

const zh_cn_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返场树种仅限 Plus 会员于活动期间内兑换。`)
};

const zh_tw_how_to_redeem_tree_list1 = /** @type {(inputs: How_To_Redeem_Tree_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回歸樹種僅限 Plus 會員於活動期間內兌換。`)
};

/**
* | output |
* | --- |
* | "Returning trees are only available to Plus members during this event." |
*
* @param {How_To_Redeem_Tree_List1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_to_redeem_tree_list1 = /** @type {((inputs?: How_To_Redeem_Tree_List1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Redeem_Tree_List1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_to_redeem_tree_list1(inputs)
	if (locale === "ar") return ar_how_to_redeem_tree_list1(inputs)
	if (locale === "de") return de_how_to_redeem_tree_list1(inputs)
	if (locale === "es") return es_how_to_redeem_tree_list1(inputs)
	if (locale === "fr") return fr_how_to_redeem_tree_list1(inputs)
	if (locale === "it") return it_how_to_redeem_tree_list1(inputs)
	if (locale === "ja") return ja_how_to_redeem_tree_list1(inputs)
	if (locale === "ko") return ko_how_to_redeem_tree_list1(inputs)
	if (locale === "pt_br") return pt_br_how_to_redeem_tree_list1(inputs)
	if (locale === "ru") return ru_how_to_redeem_tree_list1(inputs)
	if (locale === "th") return th_how_to_redeem_tree_list1(inputs)
	if (locale === "tr") return tr_how_to_redeem_tree_list1(inputs)
	if (locale === "zh_cn") return zh_cn_how_to_redeem_tree_list1(inputs)
	return zh_tw_how_to_redeem_tree_list1(inputs)
});